class Concept0ryCartFomo extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
    this.deadline = 0;
    this.durationMs = 15 * 60 * 1000;
  }

  connectedCallback() {
    this.stop();
    const durationMinutes = Number.parseFloat(this.dataset.durationMinutes || '15');
    this.durationMs = Math.max(1, durationMinutes) * 60 * 1000;
    this.autoRestart = this.dataset.autoRestart !== 'false';
    this.storageKey = `concept0ry-cart-fomo-${this.dataset.storageKey || 'default'}`;
    this.timerElement = this.querySelector('[data-cart-fomo-timer]');
    this.expiredElement = this.querySelector('[data-cart-fomo-expired]');

    if (!this.timerElement) return;

    this.deadline = this.getDeadline();
    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    this.stop();
  }

  stop() {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }

  getDeadline() {
    const now = Date.now();
    let stored = 0;

    try {
      stored = Number.parseInt(window.localStorage.getItem(this.storageKey), 10) || 0;
    } catch (error) {
      stored = 0;
    }

    if (!stored) {
      stored = now + this.durationMs;
    } else if (stored <= now && this.autoRestart) {
      const cycles = Math.floor((now - stored) / this.durationMs) + 1;
      stored += cycles * this.durationMs;
    }

    try {
      window.localStorage.setItem(this.storageKey, String(stored));
    } catch (error) {
      // Le timer continue pour la session même si le stockage est bloqué.
    }

    return stored;
  }

  tick() {
    let remaining = this.deadline - Date.now();

    if (remaining <= 0) {
      if (this.autoRestart) {
        this.deadline = Date.now() + this.durationMs;
        remaining = this.durationMs;
        try {
          window.localStorage.setItem(this.storageKey, String(this.deadline));
        } catch (error) {
          // Rien à faire.
        }
      } else {
        remaining = 0;
        this.classList.add('is-expired');
        if (this.expiredElement) this.expiredElement.hidden = false;
      }
    }

    const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const useHours = this.durationMs >= 60 * 60 * 1000;
    this.timerElement.textContent = useHours
      ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      : `${String(Math.floor(totalSeconds / 60)).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
}

if (!customElements.get('concept0ry-cart-fomo')) {
  customElements.define('concept0ry-cart-fomo', Concept0ryCartFomo);
}
